<template>
  <div
    v-if="show"
    class="softness-score-mini js-softness-score-tooltip"
    :class="{
      'softness-score-mini--vertical': vertical
    }"
    tabindex="0"
  >
    <h2 v-if="!iconOnly" class="softness-score-mini__label">
      <span class="softness-label">CozyFeel™<span class="softness-label__sublabel" /></span>
    </h2>
    <div
      class="softness-score-mini__number"
      :class="{ 'softness-score-mini__number--white-outline': iconOnly }"
    >
      {{ value }}
    </div>
  </div>
</template>

<script>
import init from "components/compositions/softness_score/component";

export default {
  name: "SoftnessScoreMini",
  props: {
    value: {
      default: 0.0,
      type: [String, Number]
    },
    vertical: {
      default: false,
      type: Boolean
    },
    iconOnly: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    show() {
      return this.value;
    }
  },
  mounted() {
    init();
  }
};
</script>
